'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounceByTick = exports.cancelSchedulerCallback = exports.requestSchedulerCallback = exports.cancelIdleCallback = exports.requestIdleCallback = undefined;

var _scheduler = require('scheduler');

var Scheduler = _interopRequireWildcard(_scheduler);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint-disable compat/compat */
var requestIdleCallback = exports.requestIdleCallback = window.requestIdleCallback || setTimeout;
var cancelIdleCallback = exports.cancelIdleCallback = window.cancelIdleCallback || clearTimeout;

var requestSchedulerCallback = exports.requestSchedulerCallback = function requestSchedulerCallback(callback) {
  return Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, callback);
};

var cancelSchedulerCallback = exports.cancelSchedulerCallback = function cancelSchedulerCallback(id) {
  if (id) {
    Scheduler.unstable_cancelCallback(id);
  }
};

/**
 * Debounce function that uses Promise resolution for timing, resulting in a shorter delay than
 * `setTimeout()` in modern browsers.
 *
 * Borrowed from Popper.js:
 * https://github.com/popperjs/popper-core/blob/be548db65912e1126581a44faa7f758ff004680a/src/utils/debounce.js
 *
 * @param {Function} callback
 */
var debounceByTick = exports.debounceByTick = function debounceByTick(callback) {
  var pending = void 0;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(callback());
        });
      });
    }

    return pending;
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/utils/Timers.js
// module id = 118
// module chunks = 177